<template>
	<frontend-layout>
		<Head>
			<title>
				{{ $t("softwareDownload") }} -
				{{ $t("siteTitle") }}
			</title>
		</Head>
		<template #header>
			<h1 class="page-title p-0">{{ $t("softwareDownload") }}</h1>
		</template>

		<template #breadcrumb>
			<div class="pageInfo mb-2 p-1">
				<div class="page-breadcrumb float-sm-right">
					<ol class="breadcrumb">
						<li class="breadcrumb-item">
							<InertiaLink
								:href="'/'"
								:class="{
									active: $page.url === '/',
								}">
								{{ $t("home") }}
							</InertiaLink>
						</li>
						<li class="breadcrumb-item">
							{{ $t("softwareDownload") }}
						</li>
					</ol>
				</div>
			</div>
		</template>

		<section class="content">
			<div class="container">
				<template v-if="Object.keys(softwareCategory).length != 0">
					<div class="ts-grid is-stackable is-4-columns">
						<div
							v-for="category in softwareCategory"
							:key="category.routeName"
							class="column">
							<a
								class="ts-box ts-text is-undecorated"
								:href="'/download/' + category.routeName">
								<div class="ts-image is-centered">
									<img
										:src="
											'/softcatimg/' + category.routeName
										" />
								</div>
								<div class="ts-content">
									<div
										class="ts-text is-bold is-big"
										v-if="$i18n.locale == 'zh-TW'">
										{{ category.title }}
									</div>
									<div class="ts-text is-bold is-big" v-else>
										{{ category.title_en }}
									</div>
									<div
										class="ts-text category-description"
										v-if="$i18n.locale == 'zh-TW'">
										{{ category.description }}
									</div>
									<div
										class="ts-text category-description"
										v-else>
										{{ category.description_en }}
									</div>
								</div>
							</a>
						</div>
					</div>
				</template>
				<template v-else>
					<div class="row not-found">
						<div class="col-12">
							<h3 class="text-center">
								{{ $t("download.noSoftware") }}
							</h3>
							<InertiaLink
								class="btn btn-primary mt-3"
								title="返回首頁"
								href="/">
								<span
									class="ts-icon is-rotate-left-icon"></span>
								{{ $t("download.backHome") }}
							</InertiaLink>
						</div>
					</div>
				</template>
			</div>
		</section>
	</frontend-layout>
</template>

<script>
// import components
import FrontendLayout from "@/Frontend/Shared/Layout";

export default {
	name: "download_Category",
	props: {
		softwareCategory: Object,
	},
	data() {
		return {};
	},
	methods: {},
	mounted() {},
	computed: {
		softwareCategory_chunk() {
			return _.chunk(this.softwareCategory, 4);
		},
	},
	components: {
		FrontendLayout,
	},
};
</script>

<style scoped>
.content {
	margin: 30px;
}
.chunk_block {
	width: 100%;
}

.category-description {
	overflow: hidden;
	display: -webkit-box;
	-webkit-line-clamp: 3;
	-webkit-box-orient: vertical;
}

.category-description:hover {
	overflow: visible;
	display: block;
}
@media only screen and (min-width: 600px) {
}

.image {
	border: 2px blue solid;
	border-radius: 1rem;
	background: none;
	position: relative;
	flex: 1;
	max-width: 300px;
	width: 300px;
	height: 300px;
	padding: 0;
	margin: 0.5rem 0.5rem;
	overflow: hidden;
}

.image img {
	position: relative;
	width: 100%;
	height: 100%;
	object-fit: contain;
	object-position: center;
}

.image .details {
	background-repeat: no-repeat;
	background-position: center center;
	background-size: cover;
	z-index: 1;
	display: flex;

	flex-direction: column;
	width: 100%;
	height: 100%;
}

.image .details h2 {
	text-align: center;
	color: black;
	text-transform: uppercase;
	font-weight: 900;

	transition: 0.4s;
	text-shadow: 1px 0px 10px white;

	transition-property: transform;
}
.image .details h2 span {
	font-weight: 900;
}

.image:hover .details h2 {
	transform: translateY(-30px);
}

.image .details p {
	font-size: 18px;
	font-weight: 600;
	background-color: none;
	opacity: 0;
	height: 0%;
	transition: 0.6s;
	transition-property: opacity, transform;
	overflow-y: scroll;
}
.image .details p > p {
	line-height: 1.5rem;
	text-decoration: none;
	color: white;
}
/* width */
.image .details p::-webkit-scrollbar {
	width: 5px;
}

/* Track */
.image .details p::-webkit-scrollbar-track {
	background: none;
}

/* Handle */
.image .details p::-webkit-scrollbar-thumb {
	background: #888;
}

/* Handle on hover */
.image .details p::-webkit-scrollbar-thumb:hover {
	background: #555;
}
.image:hover .details p {
	opacity: 1;
	width: 95%;
	height: 150px;
	transform: translateY(-40px);
	background: rgba(184, 184, 184, 0.5);
}
.image:hover .details p span {
	background-color: transparent;
}
.more {
	position: absolute;
	width: 100%;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	padding: 15px;
	bottom: -80px;
	transition: 0.6s;
	transition-property: bottom;
}
.more span {
	color: #2d5209;
	size: 24px;
	background: none;
	border-radius: 1.5rem;
	padding: 1rem;
	text-align: center;
}
.image:hover .more {
	bottom: 0;
}
@media (max-width: 1080px) {
	.image {
		flex: 100%;
		max-width: 480px;
	}
}
@media (max-width: 400px) {
	.image .details p {
		font-size: 16px;
	}
}
</style>
